import React from 'react';
import Link from 'gatsby-link';

import Button from '@marvelapp/marvel-ui/button';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import CollaborationArtwork from 'marketing-website/components/modules/CollaborationArtwork';

export default function Collaboration() {
  return (
    <PageWrap size="l">
      <Grid columns={12} alignItems="center">
        <GridItem columnSpan={12} columnSpanM={6}>
          <CollaborationArtwork color="lightOrange" patternColor="orange" />
        </GridItem>
        <GridItem columnSpan={12} columnSpanM={6}>
          <Spacing size="l" sizeM="0" type="margin" position="bottom">
            <HeadingBlock
              size="s"
              spacing="m"
              justifyM="center"
              title="Cross company collaboration, solved"
              copy={
                <span>
                  Marvel becomes a central space for all of your design needs
                  and brings your teams together through our collaboration
                  features.
                  <br />
                  <br />
                  Give your team and stakeholders full visibility across every
                  project, add unique teams, create folders and leave design
                  feedback as comments and annotations.
                </span>
              }
            >
              <Link to="/features/collaboration">
                <Button shape="rounded" size="large" kind="ghost">
                  Learn more
                </Button>
              </Link>
            </HeadingBlock>
          </Spacing>
        </GridItem>
      </Grid>
    </PageWrap>
  );
}



// WEBPACK FOOTER //
// ./src/pages/why-marvel/Collaboration.js